export enum SupportPlanTypeEnum {
  BASIC = 'BASIC',
  ADVANCED = 'ADVANCED',
  INDIVIDUAL = 'INDIVIDUAL'
}